module.exports = __webpack_public_path__ + "img/head_bg.a58be42c.jpg";